var map = {
	"./shopeeLogo.svg": 65090,
	"./shopeePayLogo.svg": 52572,
	"./shopeePayLogo2022.svg": 4462,
	"./shopeePayLogoMobile2022.svg": 77982,
	"Common/Assets/Icons/ShopeeLogo/shopeeLogo.svg": 65090,
	"Common/Assets/Icons/ShopeeLogo/shopeePayLogo.svg": 52572,
	"Common/Assets/Icons/ShopeeLogo/shopeePayLogo2022.svg": 4462,
	"Common/Assets/Icons/ShopeeLogo/shopeePayLogoMobile2022.svg": 77982
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1941;